module.exports = {"130371005":"船厂路街道","130371011":"珠江道街道","130371012":"黄河道街道","130371013":"腾飞路街道","130371200":"渤海乡","130371400":"榆关管理区","130371401":"牛头崖管理区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130371.json
// module id = 107
// module chunks = 0